exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qb--tabs .header {\n  position: relative; }\n  .qb--tabs .header h1 {\n    display: inline-block; }\n\n.qb--tabs .logos {\n  margin: auto;\n  padding: 1em;\n  font-weight: 300;\n  color: #6b6b6b;\n  font-size: 39.9px;\n  text-align: center;\n  display: inline-block; }\n  .qb--tabs .logos span {\n    margin: 1em;\n    vertical-align: middle; }\n  .qb--tabs .logos .img--mhd, .qb--tabs .logos .img--qb {\n    vertical-align: middle; }\n\n.qb--tabs .status--loading {\n  top: 50%;\n  right: 0;\n  margin-top: -10px;\n  position: absolute; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/QbTabs/qbTabs.scss
// module id = 935
// module chunks = 1